<iframe [src]="sourceUrl$ | async" [ngStyle]="customStyles$ | async" class="legacy-app" #iframe></iframe>
